"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v15Upgrade = exports.v15Downgrade = void 0;
const v15Downgrade = (rule) => {
    const { ubCode, clientUuid, embUuid, variants, trigger, published, frequency, referrerTargets, id, integrations, event, version, parentVersion, dimensions, meta, urlTargets, cookieTargets, geoTargets, scheduling, displaySettings, } = rule;
    return {
        schemaVersion: 14,
        ubCode,
        clientUuid,
        embUuid,
        variantLetter: variants.reduce((maxWeightVariant, variant) => (variant.weight > maxWeightVariant.weight ? variant : maxWeightVariant), { letter: 'a', weight: 0 }).letter,
        trigger,
        published,
        frequency,
        referrerTargets,
        id,
        integrations,
        event,
        version,
        parentVersion,
        dimensions,
        meta,
        urlTargets,
        cookieTargets,
        geoTargets,
        scheduling,
        displaySettings,
    };
};
exports.v15Downgrade = v15Downgrade;
const v15Upgrade = (rule) => {
    const { ubCode, clientUuid, embUuid, variantLetter, trigger, published, frequency, referrerTargets, id, integrations, event, version, parentVersion, dimensions, meta, urlTargets, cookieTargets, geoTargets, scheduling, displaySettings, } = rule;
    return {
        schemaVersion: 15,
        ubCode,
        clientUuid,
        embUuid,
        variants: [
            {
                // The first variant has its trackingId set equal to the rule's ID. This will allow us to
                // query stats for the variant using the trackingId and receive all stats that were
                // recorded under the activation rule ID prior to us allowing multiple variants.
                letter: variantLetter,
                trackingId: id,
                weight: 1,
            },
        ],
        trigger,
        published,
        frequency,
        referrerTargets,
        id,
        integrations,
        event,
        version,
        parentVersion,
        dimensions,
        meta,
        urlTargets,
        cookieTargets,
        geoTargets,
        scheduling,
        displaySettings,
    };
};
exports.v15Upgrade = v15Upgrade;
//# sourceMappingURL=v15.js.map